import algoliasearch from 'algoliasearch/lite'
import globals from '../../utils/globals'
import { getSearchToken, Credentials } from '../../services/algoliaService'

export interface TagHit {
  id: number
  name: string
  count: number | string
  selected?: boolean
  _highlightResult?: {
    name: {
      value: string
    }
  }
}

export interface TagSearchResults {
  hitsPerPage: number
  page: number
  queryID: string
  nbHits: number
  hits: TagHit[]
  nbPages: number
  query: string
}

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 25

export default class TagsIndex {
  private index?: algoliasearch.Index

  constructor () {
    this.cb = this.cb.bind(this)
  }

  cb (data: Credentials) {
    const client = algoliasearch(data.client_id, data.token)
    this.index = client.initIndex(`${globals('communityId')}-tags`)
  }

  async setupIndex () {
    await getSearchToken(this.cb)
  }

  async searchByName (name: string, page = DEFAULT_PAGE, pageSize = DEFAULT_PAGE_SIZE): Promise<TagSearchResults> {
    if (!this.index) {
      await this.setupIndex()
    }
    // @ts-expect-error
    return this.index.search(name, {
      // @ts-expect-error
      restrictSearchableAttributes: ['name'],
      page: page - 1,
      hitsPerPage: pageSize
    })
  }

  async getFirstRecordsFromNextPage (currentPage: number, pageSize: number = DEFAULT_PAGE_SIZE, length: number = 1) {
    if (!this.index) {
      await this.setupIndex()
    }
    // @ts-expect-error
    return this.index.search('', {
      // @ts-expect-error
      restrictSearchableAttributes: ['name'],
      offset: currentPage * pageSize,
      length: length
    })
  }

  clearCache () {
    if (!this.index) {
      return
    }

    this.index.clearCache()
  }
}
